import React from 'react'
import './IconStyles.css';
import { LuChefHat } from "react-icons/lu";

export const RecipeDesignerIcon = (props) => (
    <div style={{minWidth: "1.75em"}}>
        <LuChefHat
            color={props.color ? props.color : undefined}
            size={props.size ? props.size : "1.15em"}
        />
    </div>
)
